import React from "react";
import Container from "@mui/material/Container";
import { Box, Typography, Grid, Link as MuiLink } from "@mui/material";
import { Link, useLocation } from "react-router-dom";
import useMediaQuery from '@mui/material/useMediaQuery'; 
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import logo from "../../assets/logo_footer.png";

const pages = [
  { name: "Accueil", url: "/home" },
  { name: "Nos conseils", url: "/advice" },
  { name: "L’équipe", url: "/team" },
  { name: "Articles", url: "/articles" },
  { name: "A propos", url: "/about" },
  { name: "Nous contacter", url: "/contact" }
];

const quickLinks = [
  { name: "Privacy Policy", url: "/privacy-policy" },
  { name: "Term Of Service", url: "/terms" },
  { name: "Disclaimer", url: "/disclaimer" },
  { name: "Credits", url: "/credits" }
];

const Footer = ({marginTop}) => {
  const location = useLocation(); // Get the current route
  const isMobile = useMediaQuery('(max-width: 600px)'); // Media query for mobile view

  return (
    <Box
      sx={{
        marginTop: marginTop,
        color :"#737373",
        backgroundColor: "#090809", // AEE2F9 with 77% opacity
        padding: isMobile ? "1em 0" : "2em 0", // Adjust padding for mobile
      }}
    >
      <Container>
        {/* First Grid: Image and text, Event Location, Other Pages, Quick Links */}
        <Grid container spacing={4} justifyContent="space-between">
          {/* 1st Column - Image and Text */}
          <Grid item xs={12} sm={3}>
            {/* Placeholder for the image */}
            <Box mb={2}>
              <img src={logo} alt="Eventups logo" style={{ maxWidth: '100%' }} />
            </Box>
            <Typography variant="body2">
              Eventups is sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
            </Typography>
          </Grid>

          {/* 2nd Column - Event Location and Book Your Ticket */}
          <Grid item xs={12} sm={3}>
            <Typography sx={{
              color :"#fff"
            }} variant="subtitle1" gutterBottom>
              Event Location
            </Typography>
            <Typography variant="body2">Nusa Dua, Bali - Indonesia</Typography>
            <Typography variant="subtitle1" sx={{ mt: 2 }}>
              Book Your Ticket
            </Typography>
            <Typography variant="body2">(+021) 115-559</Typography>
          </Grid>

          {/* 3rd Column - Other Pages */}
          <Grid item xs={12} sm={3}>
            <Typography variant="h6" gutterBottom>
              Other Pages
            </Typography>
            {pages.map((page, index) => (
              <MuiLink
                key={index}
                component={Link}
                to={page.url}
                color="inherit"
                sx={{ display: "block", mb: 1, textDecoration: "none" }}
              >
                {page.name}
              </MuiLink>
            ))}
          </Grid>

          {/* 4th Column - Quick Links */}
          <Grid item xs={12} sm={3}>
            <Typography variant="h6" gutterBottom>
              Quick Links
            </Typography>
            {quickLinks.map((link, index) => (
              <MuiLink
                key={index}
                component={Link}
                to={link.url}
                color="inherit"
                sx={{ display: "block", mb: 1, textDecoration: "none" }}
              >
                {link.name}
              </MuiLink>
            ))}
          </Grid>
        </Grid>

        {/* Second Section: Social Links and Newsletter */}
        <Box mt={5} textAlign="center">
          <Grid container spacing={4} justifyContent="center">
            <Grid item xs={12} sm={6}>
              <Box display="flex" justifyContent="center" gap={2}>
                <MuiLink href="https://facebook.com" color="inherit" target="_blank" rel="noopener">
                  <FacebookIcon />
                </MuiLink>
                <MuiLink href="https://twitter.com" color="inherit" target="_blank" rel="noopener">
                  <TwitterIcon />
                </MuiLink>
                <MuiLink href="https://instagram.com" color="inherit" target="_blank" rel="noopener">
                  <InstagramIcon />
                </MuiLink>
                <MuiLink href="https://linkedin.com" color="inherit" target="_blank" rel="noopener">
                  <LinkedInIcon />
                </MuiLink>
              </Box>
            </Grid>

            {/* Newsletter Section */}
            <Grid item xs={12} sm={6}>
              <Typography variant="h6" gutterBottom>
                Subscribe Our Newsletter
              </Typography>
              <Box
                component="form"
                noValidate
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  backgroundColor: 'white',
                  borderRadius: '5px',
                  overflow: 'hidden',
                  maxWidth: '300px',
                  margin: '0 auto'
                }}
              >
                <input
                  type="email"
                  placeholder="Your Email Address"
                  style={{
                    border: 'none',
                    padding: '0.5em',
                    flexGrow: 1,
                    fontSize: '16px',
                  }}
                />
                <button
                  type="submit"
                  style={{
                    backgroundColor: '#00ffdd',
                    padding: '0.5em 1em',
                    border: 'none',
                    cursor: 'pointer',
                    fontWeight: 'bold',
                  }}
                >
                  Subscribe
                </button>
              </Box>
            </Grid>
          </Grid>
        </Box>

        {/* Third Section: Copyright */}
        <Box mt={4} textAlign="center">
          <Typography variant="body2">
            &copy; 2022 Eventups Template kit By Baliniz. All Rights Reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
